// section-collection-seasons.js
document.addEventListener('DOMContentLoaded', function () {
  const titleElement = document.getElementById('currentSeasonTitle');
  const seasonElements = document.querySelectorAll('.season-image-container');
  const dots = document.querySelectorAll('.dot');
  const seasonsContainer = document.querySelector('.seasons-container');

  // 检查 URL 参数，如果存在则滚动到指定位置
  function handleInitialPosition() {
    const urlParams = new URLSearchParams(window.location.search);
    const returnIndex = urlParams.get('return_index');

    if (returnIndex !== null) {
      // 先保持容器隐藏
      seasonsContainer.style.opacity = '0';
      seasonsContainer.style.transition = 'none';

      // 延迟一点执行，确保页面已完全加载
      setTimeout(() => {
        const targetSeason = document.querySelector(`.season-image-container[data-index="${returnIndex}"]`);
        if (targetSeason) {
          // 无动画滚动到目标位置
          targetSeason.scrollIntoView({ behavior: 'auto' });

          // 更新活动点
          updateActiveDot(parseInt(returnIndex));

          // 更新标题
          const seasonTitle = targetSeason.dataset.season;
          titleElement.textContent = seasonTitle;

          // 在页面滚动到指定位置后，从URL中删除return_index参数。这样清理URL后，如果用户刷新页面，就不会再次尝试滚动到那个位置。
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.delete('return_index');
          window.history.replaceState({}, '', newUrl);
        }

        // 滚动完成后显示内容
        setTimeout(() => {
          seasonsContainer.style.transition = 'opacity 0.3s';
          seasonsContainer.style.opacity = '1';
        }, 50);
      }, 10);
    } else {
      // 如果没有返回参数，直接显示内容
      seasonsContainer.style.opacity = '1';
    }
  }

  // 更新当前活动的点
  function updateActiveDot(index) {
    dots.forEach((dot) => dot.classList.remove('active'));
    dots[index].classList.add('active');
  }

  // 更新标题（带动画效果）
  function updateTitle(season) {
    // 避免重复更新相同的标题
    if (titleElement.textContent !== season) {
      // 淡入淡出效果
      titleElement.style.opacity = '0';
      setTimeout(() => {
        titleElement.textContent = season;
        titleElement.style.opacity = '1';
      }, 300);
    }
  }

  // 点击dot时滚动到对应的season
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const targetSeason = document.querySelector(`.season-image-container[data-index="${index}"]`);
      targetSeason.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // 使用 Intersection Observer 检测当前可见的 season
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const season = entry.target.dataset.season;
          const index = parseInt(entry.target.dataset.index); // 用于更新活动的点

          updateTitle(season);
          updateActiveDot(index); // 更新活动的点

          // 更新 URL，不刷新页面
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('return_index', index);
          window.history.replaceState({}, '', newUrl);
        }
      });
    },
    {
      threshold: 0.5, // 当50%的元素可见时触发
    },
  );

  // 观察所有季节元素
  seasonElements.forEach((season) => {
    observer.observe(season);
  });

  // 处理初始位置
  handleInitialPosition();
});
